import { useRef } from "react";
import { apiInfos } from "../Assets/API/apiInfos";
import { Link } from "react-router-dom";
import { PageNames, TabNames } from "../Assets/variables";

const DataDictionaryItem = ({ result }) => {
    const contentItemButtonElement = useRef(null);
    const contentItemAttributesElement = useRef(null);

    let apiNameInTitle = apiInfos.filter((apiInfo) => apiInfo.apiName === result.api)[0].apiTitle;

    const toggleContentItemVisibility = () => {
        if (contentItemAttributesElement.current.classList.contains("hidden")) {
            contentItemAttributesElement.current.classList.remove("hidden");
            contentItemButtonElement.current.classList.add("tab-content__field-button--shown");
        } else {
            contentItemAttributesElement.current.classList.add("hidden");
            contentItemButtonElement.current.classList.remove("tab-content__field-button--shown");
        }
    }

    let splitFieldNameInTitle = result.name.split(" / ");

    for (let i = 0; i < splitFieldNameInTitle.length; i++) {
        if (i < splitFieldNameInTitle.length - 1) {
            splitFieldNameInTitle[i] = splitFieldNameInTitle[i].concat('', " / ");
        }
    }
    
    return (
        <div className="tab-content__field" key={result.id}>
            <button onClick={toggleContentItemVisibility} className="tab-content__field-button" ref={contentItemButtonElement}>
                <div className="tab-content__field-header">
                    <div className="tab-content__field-header-title">
                        <Link className="api-name" target="_blank" to={`/${PageNames.Catalog}/${result.api}/${TabNames.Content}`}>{apiNameInTitle}</Link>
                        { splitFieldNameInTitle.map(fieldNameSegment => (
                            <span>{fieldNameSegment}</span>
                        ))}
                    </div>
                </div>
            </button>
            <div className="tab-content__field-attributes hidden" ref={contentItemAttributesElement}>
                <div className="tab-content__field-attribute">
                    <p className="tab-content__field-attribute-name">API Field Name</p>
                    <span className="tab-content__field-attribute-value">{result.apiFieldName}</span>
                </div>
                { !!result.apiFieldName &&
                    <div className="tab-content__field-attribute">
                        <p className="tab-content__field-attribute-name">Description</p>
                        <span className="tab-content__field-attribute-value">{result.description}</span>
                    </div>
                }
                { !!result.type &&
                    <div className="tab-content__field-attribute">
                        <p className="tab-content__field-attribute-name">Type</p>
                        <span className="tab-content__field-attribute-value">{result.type}</span>
                    </div>
                }
                { !!result.format &&
                    <div className="tab-content__field-attribute">
                        <p className="tab-content__field-attribute-name">Format</p>
                        <span className="tab-content__field-attribute-value">{result.format}</span>
                    </div>
                }
                { !!result.enumValues.length &&
                    <div className="tab-content__field-attribute">
                        <p className="tab-content__field-attribute-name">Enum</p>
                        <span className="tab-content__field-attribute-value">
                            <ul>
                                { result.enumValues.map(enumValue => (
                                    <li>{enumValue}</li>
                                ))}
                            </ul>
                        </span>
                    </div>
                }
            </div>
        </div>
    );
}

export default DataDictionaryItem;